/**
 * "Where are you based?", for as long as the tab is open.
 *
 * The question landed on Sept 19; `PATCH /me/onboarding` validates with a
 * strict schema and rejects the field outright, so until the backend catches up
 * the answer has nowhere on the server to live. Without this, someone would
 * answer it in the sign-up questions and find the account page's own copy of
 * the question still empty a second later, which reads as a bug rather than as
 * a gap.
 *
 * Deliberately a module variable and not `localStorage`: D10 keeps sign-up
 * answers out of storage, the URL, telemetry and analytics. A reload forgets
 * it, which is the honest thing for an answer that was never saved.
 *
 * The whole file goes the day `origin` comes back from `GET /me/onboarding`.
 */

let heldFor: string | null = null;
let held: string | null = null;
let skipped = false;

export function rememberOrigin(userId: string, origin: string | null, wasSkipped = false): void {
  heldFor = userId;
  held = origin;
  skipped = wasSkipped;
}

export function recallOrigin(userId: string): { origin: string | null; skipped: boolean } {
  if (heldFor !== userId) return { origin: null, skipped: false };
  return { origin: held, skipped };
}

/** Signing out leaves nothing of one account's answers for the next. */
export function forgetOrigin(): void {
  heldFor = null;
  held = null;
  skipped = false;
}
